import { useRef } from "react";
import { useForgeEvent } from "./hooks";
import type { PickGroup, PickOption } from "./search";

/**
 * A text field that lists matches as you type and sets one value (TAI-2305's Person filter, made
 * shared). `filter` is also called with empty text and the current value, to show the chosen
 * option's label, so it must return that option then (see `search.ts`). Mounted only once its
 * parent can render it, so the listener binds (TAI-2302).
 */
export function SearchPicker({ id, label, placeholder, value, filter, onChange, emptyMessage = "No one matches",
  block = false, required = false, supportText, minWidth = "360px" }: {
  id: string; label: string; placeholder?: string; value: string;
  filter: (text: string, value: string | null) => PickOption[] | PickGroup[]; onChange: (value: string) => void;
  emptyMessage?: string; block?: boolean; required?: boolean; supportText?: string; minWidth?: string;
}) {
  const ref = useRef<HTMLElement>(null);
  useForgeEvent(ref, "forge-autocomplete-change", (e: CustomEvent) => onChange(e.detail ? String(e.detail) : ""));
  return (
    <forge-autocomplete ref={ref} filter={filter} value={value || null} option-limit={50} empty-message={emptyMessage}>
      <forge-text-field label-position={block ? "block-start" : "inline-start"} dense={!block || undefined} show-clear
        required={required || undefined} style={block ? undefined : { minWidth }}>
        <forge-icon slot="start" name="search" />
        <label htmlFor={id}>{label}</label>
        <input id={id} type="text" autoComplete="off" placeholder={placeholder} />
        {supportText && <span slot="support-text">{supportText}</span>}
      </forge-text-field>
    </forge-autocomplete>
  );
}
